/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Component imports
import { ClockCircleOutlined, NotificationOutlined, ThunderboltOutlined, AppstoreAddOutlined, SafetyOutlined } from '@ant-design/icons';
import { POWERUPS } from './main';
import BoxIcon from '../components/Icons/BoxIcon';

// Navigation routes (general)
export const NAV_ROOT = '/';
export const NAV_AUTHORIZE = '/authorize';
export const NAV_OIDC_CALLBACK = '/oidc-callback';
export const NAV_LOGIN = '/login';
export const NAV_LOGOUT = '/logout';
export const NAV_REGISTRATION = '/register';
export const NAV_EMAIL_VERIFICATION = '/email-verification/:token?';
export const NAV_PRICING = '/pricing-calculator';
export const NAV_USER_INVITATION = '/user-invitation/:token?';
export const NAV_FORGOT_PASSWORD_REQUEST = '/forgot-password-request';
export const NAV_FORGOT_PASSWORD = '/forgot-password/:token?';

// Navigation routes (org/tenant-specific)
export const NAV_ORG_EMPTY = '/org';
export const NAV_DASHBOARD = '/org/:orgId';
export const NAV_ANALYTICS = '/observatory/:orgId/analytics';
export const NAV_ANALYTICS_PUBLIC = '/observatory/:orgId/analytics-public';
export const NAV_SCHEDULED_REPORTS = '/observatory/:orgId/scheduled-reports';
export const NAV_CHAT_SESSIONS = '/observatory/:orgId/chat-sessions';
export const NAV_MISSED_QUESTIONS = '/observatory/:orgId/missed-questions';
export const NAV_SURVEYS = '/observatory/:orgId/surveys';
export const NAV_MONITORING = '/observatory/:orgId/monitoring';
export const NAV_ORGANIZATION_TESTING = '/observatory/:orgId/tests';
export const NAV_ORGANIZATION_RESULTS = '/observatory/:orgId/results';
export const NAV_INTERACTION_LOGS = '/observatory/:orgId/interaction-logs';
export const NAV_MEDIA = '/org/:orgId/media';
export const NAV_ORGANIZATION_SETTINGS = '/org/:orgId/settings';
export const NAV_ORGANIZATION_KNOWLEDGE_BASES = '/org/:orgId/knowledge-bases';
export const NAV_ORGANIZATION_KNOWLEDGE_BASE = '/org/:orgId/knowledge-bases/:knowledgeBaseId';
export const NAV_ORGANIZATION_KNOWLEDGE_BASE_NEW = '/org/:orgId/knowledge-bases/new';
export const NAV_ORGANIZATION_USERS = '/org/:orgId/users';
export const NAV_ORGANIZATION_LOGS = '/org/:orgId/logs';
export const NAV_CONTACTS = '/org/:orgId/contacts';
export const NAV_BOTS = '/org/:orgId/bots';
export const NAV_NO_BOT = '/org/:orgId/no-agents';
export const NAV_BOT_LOADING = '/org/:orgId/bots/loading';
export const NAV_BOT = '/org/:orgId/bots/:tenantId';

export const NAV_LIVECHAT = '/org/:orgId/livechat';
export const NAV_ORGANIZATION_INTEGRATIONS = '/org/:orgId/integrations';
export const NAV_LIVECHAT_STANDALONE = '/org/:orgId/livechat/standalone';
export const NAV_BOT_PREVIEW = '/bots/:tenantId/preview';
export const NAV_SHAREPOINT_CONSENT_CALLBACK = '/integrations/sharepoint/callback';

// External navigation URLs
export const NAV_EXTERNAL_URL_FACEBOOK_MESSENGER_CONVERSATION = `https://m.me/`;

// The list of views that will appear on the sidebar
// It is based on the POWERUPS list, however it's grouped differently and only used for navigation
export const SIDEBAR_MENU_ITEMS = {
  BEHAVIOR: {
    key: 'behavior',
    icon: <BoxIcon name="bot" />,
    relatedPowerups: [POWERUPS.FLOWS.key, POWERUPS.AUTOMATED_ANSWERS.key]
  },
  ARTIFICIAL_INTELLIGENCE: {
    key: 'artificial-intelligence',
    icon: <ThunderboltOutlined />,
    relatedPowerups: [POWERUPS.AUTOMATED_ANSWERS.key]
  },
  SECURITY: {
    key: 'security',
    icon: <SafetyOutlined />,
    relatedPowerups: []
  },
  PLUGINS: {
    key: 'plugins',
    icon: <AppstoreAddOutlined />,
    relatedPowerups: []
  },
  KNOWLEDGE_BASES: {
    key: 'knowledge-base-sources',
    icon: <BoxIcon name="book-alt" />,
    relatedPowerups: []
  },
  SETTINGS: {
    key: 'settings',
    icon: <BoxIcon name="cog" />,
    relatedPowerups: [POWERUPS.SETTINGS.key]
  },
  DEPLOYMENTS: {
    key: 'deployments',
    icon: <BoxIcon name="code-alt" />,
    relatedPowerups: []
  },
  BACKUPS: {
    key: 'backups',
    icon: <BoxIcon name="data" />,
    relatedPowerups: [POWERUPS.BACKUPS.key]
  },
  BROADCASTS: {
    key: 'broadcasts',
    icon: <NotificationOutlined />,
    relatedPowerups: [POWERUPS.BROADCASTS.key]
  },
  AUTOMATIONS: {
    key: 'automations',
    icon: <ClockCircleOutlined />,
    relatedPowerups: []
  }
};
